/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PaginatedDocumented } from '../../models/paginated-documented';
import { StruttureResDto } from '../../models/strutture-res-dto';

export interface StruttureControllerFindManyStrutture$Params {
  idOrganizzazione: number;

  /**
   * Page number to retrieve. If you provide invalid value the default page number will applied
   *
   * **Example:** 1
   *
   *
   * **Default Value:** 1
   */
  page?: number;

  /**
   * Number of records per page.
   *
   *
   * **Example:** 20
   *
   *
   *
   * **Default Value:** 1
   *
   *
   *
   * **Max Value:** -1
   *
   *
   * If provided value is greater than max value, max value will be applied.
   */
  limit?: number;

  /**
   * Filter by id query param.
   *
   * **Format:** filter.id={$not}:OPERATION:VALUE
   *
   *
   *
   * **Example:** filter.id=$eq:John Doe&filter.id=$in:John Doe
   *
   * **Available Operations**
   * - $eq
   *
   * - $in
   *
   * - $and
   *
   * - $or
   */
  'filter.id'?: Array<string>;

  /**
   * Filter by tipo.id query param.
   *
   * **Format:** filter.tipo.id={$not}:OPERATION:VALUE
   *
   *
   *
   * **Example:** filter.tipo.id=$eq:John Doe&filter.tipo.id=$in:John Doe
   *
   * **Available Operations**
   * - $eq
   *
   * - $in
   *
   * - $and
   *
   * - $or
   */
  'filter.tipo.id'?: Array<string>;

  /**
   * Filter by organizzazione.id query param.
   *
   * **Format:** filter.organizzazione.id={$not}:OPERATION:VALUE
   *
   *
   *
   * **Example:** filter.organizzazione.id=$eq:John Doe&filter.organizzazione.id=$in:John Doe
   *
   * **Available Operations**
   * - $eq
   *
   * - $in
   *
   * - $and
   *
   * - $or
   */
  'filter.organizzazione.id'?: Array<string>;

  /**
   * Filter by codice query param.
   *
   * **Format:** filter.codice={$not}:OPERATION:VALUE
   *
   *
   *
   * **Example:** filter.codice=$btw:John Doe&filter.codice=$contains:John Doe
   *
   * **Available Operations**
   * - $eq
   *
   * - $gt
   *
   * - $gte
   *
   * - $in
   *
   * - $null
   *
   * - $lt
   *
   * - $lte
   *
   * - $btw
   *
   * - $ilike
   *
   * - $sw
   *
   * - $contains
   *
   * - $not
   *
   * - $and
   *
   * - $or
   */
  'filter.codice'?: Array<string>;

  /**
   * Filter by nome query param.
   *
   * **Format:** filter.nome={$not}:OPERATION:VALUE
   *
   *
   *
   * **Example:** filter.nome=$btw:John Doe&filter.nome=$contains:John Doe
   *
   * **Available Operations**
   * - $eq
   *
   * - $gt
   *
   * - $gte
   *
   * - $in
   *
   * - $null
   *
   * - $lt
   *
   * - $lte
   *
   * - $btw
   *
   * - $ilike
   *
   * - $sw
   *
   * - $contains
   *
   * - $not
   *
   * - $and
   *
   * - $or
   */
  'filter.nome'?: Array<string>;

  /**
   * Filter by indirizzo query param.
   *
   * **Format:** filter.indirizzo={$not}:OPERATION:VALUE
   *
   *
   *
   * **Example:** filter.indirizzo=$btw:John Doe&filter.indirizzo=$contains:John Doe
   *
   * **Available Operations**
   * - $eq
   *
   * - $gt
   *
   * - $gte
   *
   * - $in
   *
   * - $null
   *
   * - $lt
   *
   * - $lte
   *
   * - $btw
   *
   * - $ilike
   *
   * - $sw
   *
   * - $contains
   *
   * - $not
   *
   * - $and
   *
   * - $or
   */
  'filter.indirizzo'?: Array<string>;

  /**
   * Filter by cap query param.
   *
   * **Format:** filter.cap={$not}:OPERATION:VALUE
   *
   *
   *
   * **Example:** filter.cap=$btw:John Doe&filter.cap=$contains:John Doe
   *
   * **Available Operations**
   * - $eq
   *
   * - $gt
   *
   * - $gte
   *
   * - $in
   *
   * - $null
   *
   * - $lt
   *
   * - $lte
   *
   * - $btw
   *
   * - $ilike
   *
   * - $sw
   *
   * - $contains
   *
   * - $not
   *
   * - $and
   *
   * - $or
   */
  'filter.cap'?: Array<string>;

  /**
   * Filter by luogo.codice query param.
   *
   * **Format:** filter.luogo.codice={$not}:OPERATION:VALUE
   *
   *
   *
   * **Example:** filter.luogo.codice=$btw:John Doe&filter.luogo.codice=$contains:John Doe
   *
   * **Available Operations**
   * - $eq
   *
   * - $gt
   *
   * - $gte
   *
   * - $in
   *
   * - $null
   *
   * - $lt
   *
   * - $lte
   *
   * - $btw
   *
   * - $ilike
   *
   * - $sw
   *
   * - $contains
   *
   * - $not
   *
   * - $and
   *
   * - $or
   */
  'filter.luogo.codice'?: Array<string>;

  /**
   * Filter by localita query param.
   *
   * **Format:** filter.localita={$not}:OPERATION:VALUE
   *
   *
   *
   * **Example:** filter.localita=$btw:John Doe&filter.localita=$contains:John Doe
   *
   * **Available Operations**
   * - $eq
   *
   * - $gt
   *
   * - $gte
   *
   * - $in
   *
   * - $null
   *
   * - $lt
   *
   * - $lte
   *
   * - $btw
   *
   * - $ilike
   *
   * - $sw
   *
   * - $contains
   *
   * - $not
   *
   * - $and
   *
   * - $or
   */
  'filter.localita'?: Array<string>;

  /**
   * Filter by telefono query param.
   *
   * **Format:** filter.telefono={$not}:OPERATION:VALUE
   *
   *
   *
   * **Example:** filter.telefono=$btw:John Doe&filter.telefono=$contains:John Doe
   *
   * **Available Operations**
   * - $eq
   *
   * - $gt
   *
   * - $gte
   *
   * - $in
   *
   * - $null
   *
   * - $lt
   *
   * - $lte
   *
   * - $btw
   *
   * - $ilike
   *
   * - $sw
   *
   * - $contains
   *
   * - $not
   *
   * - $and
   *
   * - $or
   */
  'filter.telefono'?: Array<string>;

  /**
   * Filter by eMail query param.
   *
   * **Format:** filter.eMail={$not}:OPERATION:VALUE
   *
   *
   *
   * **Example:** filter.eMail=$btw:John Doe&filter.eMail=$contains:John Doe
   *
   * **Available Operations**
   * - $eq
   *
   * - $gt
   *
   * - $gte
   *
   * - $in
   *
   * - $null
   *
   * - $lt
   *
   * - $lte
   *
   * - $btw
   *
   * - $ilike
   *
   * - $sw
   *
   * - $contains
   *
   * - $not
   *
   * - $and
   *
   * - $or
   */
  'filter.eMail'?: Array<string>;

  /**
   * Filter by urlWeb query param.
   *
   * **Format:** filter.urlWeb={$not}:OPERATION:VALUE
   *
   *
   *
   * **Example:** filter.urlWeb=$btw:John Doe&filter.urlWeb=$contains:John Doe
   *
   * **Available Operations**
   * - $eq
   *
   * - $gt
   *
   * - $gte
   *
   * - $in
   *
   * - $null
   *
   * - $lt
   *
   * - $lte
   *
   * - $btw
   *
   * - $ilike
   *
   * - $sw
   *
   * - $contains
   *
   * - $not
   *
   * - $and
   *
   * - $or
   */
  'filter.urlWeb'?: Array<string>;

  /**
   * Parameter to sort by.
   * To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting
   *
   * **Format:** {fieldName}:{DIRECTION}
   *
   *
   * **Example:** sortBy=id:DESC&sortBy=tipo.id:DESC
   *
   *
   * **Default Value:** id:ASC
   *
   * **Available Fields**
   * - id
   *
   * - tipo.id
   *
   * - organizzazione.id
   *
   * - codice
   *
   * - nome
   *
   * - indirizzo
   *
   * - cap
   *
   * - luogo.codice
   *
   * - localita
   *
   * - telefono
   *
   * - eMail
   *
   * - urlWeb
   */
  sortBy?: Array<
    | 'id:ASC'
    | 'id:DESC'
    | 'tipo.id:ASC'
    | 'tipo.id:DESC'
    | 'organizzazione.id:ASC'
    | 'organizzazione.id:DESC'
    | 'codice:ASC'
    | 'codice:DESC'
    | 'nome:ASC'
    | 'nome:DESC'
    | 'indirizzo:ASC'
    | 'indirizzo:DESC'
    | 'cap:ASC'
    | 'cap:DESC'
    | 'luogo.codice:ASC'
    | 'luogo.codice:DESC'
    | 'localita:ASC'
    | 'localita:DESC'
    | 'telefono:ASC'
    | 'telefono:DESC'
    | 'eMail:ASC'
    | 'eMail:DESC'
    | 'urlWeb:ASC'
    | 'urlWeb:DESC'
  >;

  /**
   * Search term to filter result values
   *
   * **Example:** John
   *
   *
   * **Default Value:** No default value
   */
  search?: string;

  /**
   * List of fields to search by term to filter result values
   *
   * **Example:** id,tipo.id,organizzazione.id,codice,nome
   *
   *
   * **Default Value:** By default all fields mentioned below will be used to search by term
   *
   * **Available Fields**
   * - id
   *
   * - tipo.id
   *
   * - organizzazione.id
   *
   * - codice
   *
   * - nome
   *
   * - indirizzo
   *
   * - cap
   *
   * - luogo.codice
   *
   * - localita
   *
   * - telefono
   *
   * - eMail
   *
   * - urlWeb
   */
  searchBy?: Array<string>;
}

export function struttureControllerFindManyStrutture(
  http: HttpClient,
  rootUrl: string,
  params: StruttureControllerFindManyStrutture$Params,
  context?: HttpContext,
): Observable<
  StrictHttpResponse<
    PaginatedDocumented & {
      data?: Array<StruttureResDto>;
      meta?: {
        select?: Array<string>;
        filter?: {
          id?: string | Array<string>;
          'tipo.id'?: string | Array<string>;
          'organizzazione.id'?: string | Array<string>;
          codice?: string | Array<string>;
          nome?: string | Array<string>;
          indirizzo?: string | Array<string>;
          cap?: string | Array<string>;
          'luogo.codice'?: string | Array<string>;
          localita?: string | Array<string>;
          telefono?: string | Array<string>;
          eMail?: string | Array<string>;
          urlWeb?: string | Array<string>;
        };
      };
    }
  >
> {
  const rb = new RequestBuilder(
    rootUrl,
    struttureControllerFindManyStrutture.PATH,
    'get',
  );
  if (params) {
    rb.path('idOrganizzazione', params.idOrganizzazione, {});
    rb.query('page', params.page, {});
    rb.query('limit', params.limit, {});
    rb.query('filter.id', params['filter.id'], {});
    rb.query('filter.tipo.id', params['filter.tipo.id'], {});
    rb.query(
      'filter.organizzazione.id',
      params['filter.organizzazione.id'],
      {},
    );
    rb.query('filter.codice', params['filter.codice'], {});
    rb.query('filter.nome', params['filter.nome'], {});
    rb.query('filter.indirizzo', params['filter.indirizzo'], {});
    rb.query('filter.cap', params['filter.cap'], {});
    rb.query('filter.luogo.codice', params['filter.luogo.codice'], {});
    rb.query('filter.localita', params['filter.localita'], {});
    rb.query('filter.telefono', params['filter.telefono'], {});
    rb.query('filter.eMail', params['filter.eMail'], {});
    rb.query('filter.urlWeb', params['filter.urlWeb'], {});
    rb.query('sortBy', params.sortBy, {});
    rb.query('search', params.search, {});
    rb.query('searchBy', params.searchBy, {});
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<
          PaginatedDocumented & {
            data?: Array<StruttureResDto>;
            meta?: {
              select?: Array<string>;
              filter?: {
                id?: string | Array<string>;
                'tipo.id'?: string | Array<string>;
                'organizzazione.id'?: string | Array<string>;
                codice?: string | Array<string>;
                nome?: string | Array<string>;
                indirizzo?: string | Array<string>;
                cap?: string | Array<string>;
                'luogo.codice'?: string | Array<string>;
                localita?: string | Array<string>;
                telefono?: string | Array<string>;
                eMail?: string | Array<string>;
                urlWeb?: string | Array<string>;
              };
            };
          }
        >;
      }),
    );
}

struttureControllerFindManyStrutture.PATH =
  '/admin/strutture/{idOrganizzazione}';
